
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ylabkcykcdkzmywqsawn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlsYWJrY3lrY2Rrem15d3FzYXduIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk2OTY5MTUsImV4cCI6MjA1NTI3MjkxNX0.xtFwTxdkXSLSEvH-Jz3-XuxSmP2kfUeUUXOlNV27YrY";

const isCallbackRoute = window.location.pathname === '/auth/callback';

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      persistSession: true,
      storage: localStorage,
      detectSessionInUrl: isCallbackRoute,
      autoRefreshToken: true,
      flowType: 'pkce'
    }
  }
);
